export const TabOptions = selectedPortalUsers => [
  ...selectedPortalUsers.role !== 'SPEAKER'
    ? [
      {
        value: 'expo_magazine',
        label: 'EXPO_MAGAZINE'
      },
      {
        value: 'your_upload',
        label: 'YOUR_UPLOADS'
      },
    ] : [],
  ...selectedPortalUsers.role !== 'SPEAKER' && selectedPortalUsers.is_multiple_brands
    ? [
      {
        value: 'brands',
        label: 'BRAND'
      },
    ] : [],
  ... (selectedPortalUsers.role === 'SPEAKER' || selectedPortalUsers.is_also_speaker)
    ? [
      {
        value: 'speakers',
        label: 'SPEAKER'
      },
    ] : [],
  ... (selectedPortalUsers.role === 'EXHIBITOR')
    ? [
      {
        value: 'match_making',
        label: 'HAS_MATCHMAKING'
      },
    ] : []
]